import React from 'react'
import { Outlet } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.min.css'
import { Section, ToastWrapper } from '../../App.styled'
import AppThemeProvider from '../../style/theme/provider'

const AuthChrome = () => (
	<AppThemeProvider>
		<Section className="authWrapper">
			<Outlet />
			<ToastWrapper>
				<ToastContainer />
			</ToastWrapper>
		</Section>
	</AppThemeProvider>
)

AuthChrome.displayName = 'AuthChrome'
export default AuthChrome
